import { Query } from '@repo/graphql/graphql'
import {
  GET_ACHIEVEMENT_CARD_INFO,
  GET_ACHIEVEMENT_LIST_INFO,
  GET_LEVEL_UP_INFO,
} from '../../graphQL/queryInfo/achievement/queries'
import { useGraphQLQuery } from '../../hooks/common/useGraphQL'

export const useAchievementListInfo = (variables = {}, options = {}) => {
  return useGraphQLQuery<Query>({
    gqlQuery: GET_ACHIEVEMENT_LIST_INFO,
    queryKey: [GET_ACHIEVEMENT_LIST_INFO, variables],
    variables: variables,
    options: options,
  })
}

export const useAchievementCardInfo = (variables = {}, options = {}) => {
  return useGraphQLQuery<Query>({
    gqlQuery: GET_ACHIEVEMENT_CARD_INFO,
    queryKey: [GET_ACHIEVEMENT_CARD_INFO, variables],
    variables: variables,
    options: options,
  })
}

export const useLevelUpInfo = (variables = {}, options = {}) => {
  return useGraphQLQuery<Query>({
    gqlQuery: GET_LEVEL_UP_INFO,
    queryKey: [GET_LEVEL_UP_INFO, variables],
    variables: variables,
    options: options,
  })
}
